import { connect } from 'react-redux';
import CatatBuku from '../../../views/Library/CatatBuku/CatatBuku.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(CatatBuku);
